module.exports = __webpack_public_path__ + "img/photo1.347b87e3.png";